// Integration in Android and iOS app

import { autorun } from "mobx";
import { routerStore } from "./url/WSRouter";

/**
 * Setup communication between web and wtApp
 */
export function setupWtApp() {
  if (!window.iswtapp) {
    return;
  }

  onWtappBridgeReady(() => {
    sendMessageToWtApp("wtapp-bridge-up");
    checkForLoggedOut();
  });

  // when using back button page is cached (at least on ios) so we need to inform wtapp that the bridge is up
  // (it is up from last time, but wtapp doesn't know)
  window.addEventListener("pageshow", () => {
    onWtappBridgeReady(() => {
      sendMessageToWtApp("wtapp-bridge-up");
      checkForLoggedOut();
    });
  });

  autorun(() => {
    if (routerStore.location && window.iswtapp) {
      // wtapp does not know when we SPA navigate
      // so we need to inform it about the new url
      let url = location.origin + routerStore.location.pathname;
      if (routerStore.location.search) {
        url += routerStore.location.search;
      }
      if (routerStore.location.hash) {
        url += routerStore.location.hash;
      }

      sendMessageToWtApp("wtapp-new-url:" + url);
    }
  });
}

function checkForLoggedOut() {
  const isLoggedOut = false;

  if (isLoggedOut) {
    sendMessageToWtApp("wtapp-lock-invalidate-url");
  }
}

export function sendMessageToWtApp(message: string) {
  console.log("sendMessageToWtApp", message);

  window.postMessage(message, "*"); // deprecated
  window.wtappBridge?.postMessage?.(message);
}

function onWtappBridgeReady(callback) {
  if (window.wtappBridgeReady) {
    callback();
  } else {
    console.log("Queued function for wtappBridgeReady");
    console.log(callback);

    // deprecated start
    if (window._onWtappBridgeReady === undefined) {
      window._onWtappBridgeReady = [];
    }
    window._onWtappBridgeReady.push(callback);
    // deprecated stop

    const callbackWrapper = function () {
      callback();
      // wtapp-bridge-ready may be fired several times so we must remove the callback
      window.removeEventListener("wtapp-bridge-ready", callbackWrapper);
    };

    window.addEventListener("wtapp-bridge-ready", callbackWrapper);
  }
}

function isWtAppUrl(url: string) {
  var appUrls = [
    "localhost:44425",
    "10.0.2.108:8080",
    "10.0.2.2:8080",
    "https://cv.webtemp.no",
    "https://utvikling-bff.webtemp.no/",
    "https://bff.webtemp.no/",
    "javascript:__",
  ];

  return appUrls.some((appUrl) => url.startsWith(appUrl));
}

function isValidExternalUrl(url: string) {
  return (url && url.startsWith("http://")) || url.startsWith("https://");
}

/**
 * returns TRUE if link was handled specifically by WtApp,
 * return FALSE if it should be handled normally
 */
export function handleUrlInWtApp(url: string) {
  if (!window.iswtapp) {
    return false;
  }

  // When a link is clicked in the webview, we need to check if it should be opened in the wtApp or externally.
  const shouldOpenUrlExternally = !isWtAppUrl(url) && isValidExternalUrl(url);

  if (shouldOpenUrlExternally) {
    sendMessageToWtApp("wtapp-open-link:" + url);

    return true;
  }

  return false;
}

export function logoutWtApp() {
  if (!window.iswtapp) {
    return;
  }

  sendMessageToWtApp("wtapp-lock-invalidate-url");
}

export function wtAppGoBack() {
  sendMessageToWtApp("wtapp-go-back");
}
